<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import SelectCategoriaLeilao from './SelectCategoria'
  import service from '../../../../domain/leiloes/services'
  import GraficoLeilaoDash from './GraficoLeilao'
  import * as Status from '../../../../domain/leiloes/helpers/LeilaoStatus'
  import BtnStatus from './BtnStatus'
  import BtnStatusConfirmar from './ConfirmStatus'
  import FiltrosLote from './FiltroLote'
  import BtnRelatorios from './BtnRelatorios'
  import BtnRelatoriosPreparacaoLeilao from './BtnRelatoriosPreparacaoLeilao'
  import BtnControle from './BtnControle'
  import BtnAcoes from './BtnLeilaoAcoes'
  import EmailCobrancaView from './EmailCobrancaView'
  import EmailAutomaticoView from './EmailsAutomaticosView'
  import FiltroStatusLotes from './FiltroStatusLotes'
  import CopiarLotesView from './CopiarLotesView'
  import ACL from '../../../../domain/acl/tmp-acl'
  import { mapGetters } from 'vuex'
  import ShellSync from './ShellSync'
  import * as GrvStatus from '../../../../domain/grv/helpers/GrvStatus'
  import BtnEdital from './BtnEdital'
  import {isArray} from 'lodash'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import {STATUS_RETIRADO, Status as LoteStatus} from '../../../../domain/leiloes/helpers/LoteStatus'
  import BtnAcoesComplementaresPreparacaoLeilao from './BtnAcoesComplementaresPreparacaoLeilao'
  import BtnAcoesPlanilhasLeilao from './BtnAcoesPlanilhasLeilao'
  import {
    TIPO_RELATORIO_CSV_GRV,
    TIPO_RELATORIO_IMPORTACAO_SECUNDARIA
  } from '../../../../domain/leiloes/helpers/tipos-relatorios-preparacao'
  import * as grvTipo from '../../../../domain/grv/helpers/tipos-grv'
  import createDownloadLink from '../../../../utils/create-download-link'

export default {
    components: {
      BtnAcoesPlanilhasLeilao,
      BtnAcoesComplementaresPreparacaoLeilao,
      BtnEdital,
      ShellSync,
      CopiarLotesView,
      FiltroStatusLotes,
      EmailCobrancaView,
      EmailAutomaticoView,
      BtnAcoes,
      BtnControle,
      BtnRelatorios,
      BtnRelatoriosPreparacaoLeilao,
      FiltrosLote,
      BtnStatusConfirmar,
      BtnStatus,
      GraficoLeilaoDash,
      SelectCategoriaLeilao,
      PopupViewer,
      ResultadoGeracaoLotesLeilao: () => import('./ResultadoGeracaoLotesLeilao'),
      HistoricoLogsImportacaoPreparacaoLeilao: () => import('./HistoricoLogsImportacaoPreparacaoLeilao'),
      ResultadoDestinatarios: () => import('./ResultadoDestinatarios')

    },
    nome: 'ver-leilao',
    directives: {mask},
    data () {
      let situacaoLote = [
        {label: 'Rascunho', value: 0, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Aberto para Lances', value: 1, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Vendido', value: 6, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Condicional', value: 7, class: 'btn-default'}, /*,  class: 'btn-primary' */
        {label: 'Sem Licitante', value: 8, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Baixa Oferta', value: 9, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Retirado', value: 10, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Fechado', value: 11, class: 'btn-default'} /* , class: 'btn-success' */
      ]
      const diasVeiculoNoPatioOptions = [
        {label: '30 dias', value: 30, class: 'btn-default'},
        {label: '60 dias', value: 60, class: 'btn-default'},
        {label: '90 dias ou mais', value: 90, class: 'btn-default'}
      ]
      const tipoProcessos = [
        {label: grvTipo.getLabel(grvTipo.GRV_DETRO), value: grvTipo.GRV_DETRO, class: 'btn-default'},
        {label: grvTipo.getLabel(grvTipo.GRV_POLICIA_CIVIL), value: grvTipo.GRV_POLICIA_CIVIL, class: 'btn-default'}
      ]
      return {
        leilao: null,
        grvsAptas: null,
        activeChart1: true,
        isLoading: false,
        isUploadingDocumento: false,
        isDetro: true,
        isSucata: false,
        filterKey: '',
        sortKey: '',
        filtro: {
          tipo: '',
          situacao: situacaoLote.map(a => a.value)
        },
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        checkedAll: false,
        grvsChecked: [],
        lotesChecked: [],
        actionCheckedLotes: '',
        tiposLote: [
          {label: 'Todos', value: '', class: 'btn-default'},
          {label: 'Online', value: 2, class: 'btn-default'},
          {label: 'Presencial', value: 1, class: 'btn-default'}
        ],
        entidades: [],
        situacaoLote: situacaoLote,
        sync: false,
        shellResponse: [],
        diasVeiculoNoPatioOptions: diasVeiculoNoPatioOptions,
        tipoProcessos: tipoProcessos,
        diasVeiculoNoPatio: 30,
        visibilityOptions: [
          {label: 'Mostrar na home', value: true, class: 'btn-default'},
          {label: 'Ocultar da home', value: false, class: 'btn-default'}
        ],
        forceCadastroManual: false,
        showResultadosGeracaoLotes: false,
        importadoPorCsvPlacas: false,
        importacaoCsvPlacas: {
          grvsInvalidas: [],
          grvsNaoEncontradas: []
        },
        tipoProcesso: 0,
        showResultadosImportacaoCsvPlacas: false,
        showResultadosImportacaoSecundaria: false,
        showResultadosDestinatarios: false,
        STATUS_RETIRADO,
        forcarNovaImportacao: false,
        showRelatorioPreparacaoLeilaoViewer: false,
        relatioPreparacaoLeilaoViewerProps: {}
      }
    },
    computed: {
      urlGrv () {
        return this.isDetro ? 'grv.visualizar.patio' : 'roubo-furto.visualizar.patio'
      },
      isLeilaoPreparado () {
        if (this.forcarNovaImportacao) return false
        return this.forceCadastroManual || this.leilao && ((this.leilao.lotes || []).length || this.leilao.preparado) || false
      },
      filteredDataGrvs () {
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let data = this.grvsAptas
        let sortKey = this.sortKey
        let order = this.sortOrders[sortKey] || 1

        if (!Array.isArray(data)) {
          data = []
        }
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }

        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      filteredDataLotes: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let filtrosFixos = this.filtro
        let order = this.sortOrders[sortKey] || 1
        let data = this.leilao.lotes
        if (!Array.isArray(data)) {
          data = []
        }
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        // Situação
        let that = this
        data = data.filter(function (row) {
          if (filtrosFixos.situacao.length === that.situacaoLote.length) {
            return true
          }
          return filtrosFixos.situacao.some(el => el === row.status)
        })
        // Tipo
        if (filtrosFixos.tipo) {
          data = data.filter(function (row) {
            /* if (row.status !== 6) {
              return false // Não foi arrematado
            } */
            let test
            if (filtrosFixos.tipo === 2) { // Online
              test = row.ultimoLanceApelido !== 'PLATEIA'
            } else if (filtrosFixos.tipo === 1) { // Presencial
              test = row.ultimoLanceApelido === 'PLATEIA'
            } else {
              test = true
            }
            return test
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      getStatus () {
        return Status.Status
      },
      Status () {
        return Status
      },
      subTotalMinimo () {
        let total = 0
        if (!this.leilao.lotes) {
          return 0
        }
        this.filteredDataLotes.forEach(function (lote) {
          total += Number(lote.valorMinimo)
        })
        return total
      },
      comissaoMinimo () {
        return this.subTotalMinimo * (Number(this.leilao.comissao) / 100)
      },
      subTotalMeta () {
        let total = 0
        if (!this.leilao.lotes) {
          return 0
        }
        this.filteredDataLotes.forEach(function (lote) {
          total += Number(lote.valorMeta)
        })
        return total
      },
      comissaoMeta () {
        return this.subTotalMeta * (Number(this.leilao.comissao) / 100)
      },
      subTotalLances () {
        let total = 0
        if (!this.leilao.lotes) {
          return 0
        }
        this.filteredDataLotes.forEach(function (lote) {
          if (lote.ultimoLanceValor) {
            total += Number(lote.ultimoLanceValor)
          }
        })
        return total
      },
      comissaoLances () {
        return this.subTotalLances * (Number(this.leilao.comissao) / 100)
      },
      subTotalArremate () {
        let total = 0
        if (!this.leilao.lotes) {
          return 0
        }
        this.filteredDataLotes.forEach(function (lote) {
          total += Number(lote.valorArremate)
        })
        return total
      },
      subTotalArremateComTaxas () {
        let total = 0
        if (!this.leilao.lotes) {
          return 0
        }
        this.filteredDataLotes.forEach(function (lote) {
          if (lote.ultimoLanceValor) {
            total += Number(lote.valorComTaxas)
          }
        })
        return total
      },
      comissaoArremate () {
        return this.subTotalArremate * (Number(this.leilao.comissao) / 100)
      },
      ACL () {
        return ACL
      },
      ...mapGetters(['currentUser']),
      ENV_INFRA () {
        return process.env.INFRA
      },
      isNenhumLoteGerado () {
        const {lotesNaoGerados} = this.leilao
        return (lotesNaoGerados && lotesNaoGerados.length) === this.leilao.quantidadeDeGrvsSelecionadas
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.load()
    },
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      load () {
        this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
        service.find(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.leilao = response.data
            this.isDetro = this.leilao.comitentes[0].id === 1
            this.isSucata = this.leilao.sucata
            console.log(this.isSucata)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      checkLote (lote) {
        this.actionCheckedLotes = ''
        setTimeout(() => {
          if (lote.checked) {
            if (this.lotesChecked.indexOf(lote.id) === -1) {
              this.lotesChecked.push(lote.id)
            }
          } else {
            this.lotesChecked.splice(this.lotesChecked.indexOf(lote.id), 1)
          }
        }, 300)
      },
      _actionCheckedLotes (e) {
        let action = this.actionCheckedLotes
        let that = this
        if (action === 'deletar') {
          if (parseInt(this.leilao.status) === 6) {
            alert('Não é possível excluir lotes durante o pregão do leilão.')
            return
          }
          this.$confirm.open('Tem certeza que deseja excluir este lote de forma definitiva? Todos os lances, fotos, histórico de cadastro em favoritos e quaisquer outras informações relacionadas a este lote serão excluídas.', {
            message: 'Excluir',
            color: 'btn-danger'
          }, 'Cancelar', null, (v) => {
            if (v === false) {
              return
            }
            console.log('Excluindo lote...')
            that.$loaderOverlay.open().message('Excluindo lote')
            service.excluirLotes(that.leilao.id, that.lotesChecked)
              .then((response) => {
                that.$loaderOverlay.hide()
                that.actionCheckedLotes = ''
                // Exclui da lista
                /* that.leilao.lotes.forEach((lote, index) => {
                  if (that.lotesChecked.indexOf(lote) > -1) {
                    that.leilao.lotes.splice(that.leilao.lotes.indexOf(lote), 1)
                  }
                }) */
                that.leilao.lotes = that.leilao.lotes.slice().filter((lote) => that.lotesChecked.indexOf(lote.id) === -1)
                that.lotesChecked = []
              })
              .catch((response) => {
                this.$refs.changeStatus.close()
                window.responseError(response)
                console.log(response)
              })
          })
        } else if (action === 'copiar') {
          if (parseInt(this.leilao.status) === 6) {
            alert('Não é possível copiar lotes durante o pregão do leilão.')
            return
          }
          this.$refs.copiarLotesView.load(this.leilao.id, this.leilao.lotes.slice().filter((lote) => that.lotesChecked.indexOf(lote.id) !== -1))
        }
      },
      bindClassLoteList (lote) {
        return {
          arrematado: lote.valorArremate && Number(lote.valorArremate) > 0,
          emPregao: parseInt(lote.status) >= 2 && parseInt(lote.status) <= 5,
          'bloqueado-para-leilao': lote.bloqueadoParaLeilao
        }
      },
      sortBy: function (key) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      },
      print: function () {
        window.print()
      },
      HelperTipo (v) {
        return Status.Tipo[v]
      },
      confirmarAlteracaoStatus (v) {
        this.$refs.confirmarStatus.open(v, this.leilao.status, 'undefined', (newStatus) => {
          let oldStatus = this.leilao.status
          this.leilao.status = newStatus
          service.atualizaStatusLeilao(this.leilao.id, newStatus)
            .then((response) => {
              // nothing to do
            })
            .catch((response) => {
              window.alert('Não foi possível atualizar o status, algum problema ocorreu, tente novamente.')
              this.leilao.status = oldStatus
              console.log(response)
            })
        })
        console.log(v)
      },
      openLote (leilao, id) {
        this.$router.push({name: 'lotes.visualizar', params: {leilao: leilao, id: id}})
      },
      cadastraLote () {
        this.$router.push({name: 'lotes.novo', params: {leilao: this.leilao.id}})
      },
      uploadDocumento (e) {
        this.isUploadingDocumento = true
        let formData = new FormData()
        formData.append('file', e.target.files[0], e.target.files[0].name)
        let nome = prompt('Qual o nome do documento?')
        formData.set('nome', nome)
        // this.$refs.fileDocumento.value = ''
        service.uploadDocumentoLeilao(this.leilao.id, nome, formData)
          .then((response) => {
            this.isUploadingDocumento = false
            // this.$set(this.lote.fotos, response.data)
            this.leilao.documentos.push(response.data)
            console.log(response)
          })
          .catch((response) => {
            this.isUploadingDocumento = false
            window.alert('Não foi possível fazer o upload do documento, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      },
      removeDocumento (id) {
        if (!window.confirm('Tem certeza que deseja remover este documento?')) {
          return
        }
        let _node = this.$el.querySelector('#documento' + id)
        console.log(_node)
        _node.classList.add('hide')
        let parent = _node.parentNode
        service.deleteDocumentoLeilao(this.leilao.id, id)
          .then((response) => {
            parent.removeChild(_node)
            console.log(response)
          })
          .catch((response) => {
            window.alert('Não foi possível deletar, algum problema ocorreu, tente novamente.')
            _node.classList.remove('hide')
            console.log(response)
          })
      },
      editar () {
        this.$router.push({name: 'leiloes.editar', params: {id: this.leilao.id}})
      },
      abrirPregao () {
        this.$router.push({name: 'pregao', params: {id: this.leilao.id}})
      },
      abrirPregaoLeiloeiro () {
        this.$router.push({name: 'pregaoleiloeiro', params: {id: this.leilao.id}})
      },
      abrirMonitorComitente () {
        this.$router.push({name: 'leilao.monitor-comitente', params: {leilao: this.leilao.id}})
      },
      renovarCache () {
        this.$loaderOverlay.open().message('Renovando cache do leilão e lotes...')
        service.renovaCache(this.leilao.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Cache renovado com sucesso')
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            window.responseError(response)
            console.log(response)
          })
      },
      updateTransmissaoUrl () {
        let url = prompt('Digite a URL da transmissão', '')
        if (url === null || url === '' || url === ' ') { // TODO: Regex valid url
          return
        }
        this.$loaderOverlay.open().message('Atualizando transmissão, aguarde...')
        service.updateUrlVideoComitente(url)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Transmissão atualizada com sucesso!')
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            window.responseError(response)
            console.log(response)
          })
      },
      sincronizarLeilaoLocal () {
        this.sync = true
        service.iniciaSincronizacaoLocal(this.leilao.id)
          .then((response) => {
            console.log(response)
            this.shellResponse = response.data.output
          })
          .catch((error) => {
            alert('Erro ao rodar o script.')
            console.log(error)
          })
      },
      gerarPlanilha005 () {
        const loteSemGrv = this.leilao.lotes.find(lote => !lote.grvId && lote.status !== STATUS_RETIRADO)
        if (loteSemGrv) {
          if (!confirm(`O lote #${loteSemGrv.numero} não possui GRV relacionada. Tem certeza?`)) return
        }
        const messages = [
          `Obtendo informações dos lotes, aguarde...`,
          'Como há consulta ao webservice da DETRO, pode demorar alguns minutos',
          'Não recarregue a página durante o processo.'
        ]
        const interval = this.triggerLoopingMessages(messages, 10000)
        service.gerarPlanilha005(this.leilao.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `TRANSACIONAL_005_${this.leilao.titulo}.xls`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            clearInterval(interval)
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
          clearInterval(interval)
          alert(this.printError(response.data.errors))
        })
      },
      prepararLeilao () {
        const messages = [
          `Obtendo GRVs aptas para o leilão...
           (Somente veículos com ${this.diasVeiculoNoPatio === 90 ? '90 dias ou mais' : this.diasVeiculoNoPatio + ' a ' + (this.diasVeiculoNoPatio + 30) + ' dias'} no pátio)`,
          'Como há consulta ao webservice da DETRO, pode demorar alguns minutos...'
        ]
        const interval = this.triggerLoopingMessages(messages, 15000)
        service.prepararLeilao(this.leilao.id, this.diasVeiculoNoPatio, this.tipoProcesso)
          .then((response) => {
            this.clearFields()
            // TODO: TRATAMENTO DE ERROS DA RESPONSE
            const {aptas, erros} = response.data
            erros.length && console.log(erros)
            this.grvsAptas = aptas
            if (!(this.grvsAptas && this.grvsAptas.length)) {
              alert('Nenhuma grv está apta para leilão nessas condições!')
            }
            this.$loaderOverlay.hide()
            clearInterval(interval)
          })
          .catch((error) => {
            alert('Erro ao carregar GRVs')
            console.log(error)
            this.$loaderOverlay.hide()
            clearInterval(interval)
          })
      },
      prepararLeilaoComCsvDePlacas (e) {
        const clearInput = () => {
          this.$refs.inputCsvPlacas.value = ''
        }

        const formData = new FormData()
        formData.append('file', e.target.files[0], e.target.files[0].name)

        const messages = [
          'Obtendo GRVs aptas para o leilão...'
        ]
        const interval = this.triggerLoopingMessages(messages, 15000)
        service.uploadCsvPlacas(this.leilao.id, formData)
          .then((response) => {
            console.log(response)
            this.importadoPorCsvPlacas = true
            this.clearFields()
            // TODO: TRATAMENTO DE ERROS DA RESPONSE
            const {aptas, erros, grvsInvalidas, grvsNaoEncontradas} = response.data
            erros.length && console.log(erros)
            this.grvsAptas = aptas
            this.grvsAptas.forEach(item => {
              item.checked = true
              this.grvsChecked.push(item.id)
            })
            this.checkedAll = true
            this.importacaoCsvPlacas.grvsInvalidas = grvsInvalidas
            this.importacaoCsvPlacas.grvsNaoEncontradas = grvsNaoEncontradas
            // this.checkAllGrvs()
            this.$loaderOverlay.hide()
            clearInterval(interval)
            clearInput()
          })
          .catch((error) => {
            alert('Erro ao carregar GRVs')
            console.log(error)
            this.$loaderOverlay.hide()
            clearInterval(interval)
            clearInput()
          })
      },
      importacaoSecundaria (e) {
        const clearInput = () => {
          this.$refs.inputImportacaoSecundaria.value = ''
        }

        const formData = new FormData()
        formData.append('file', e.target.files[0], e.target.files[0].name)

        const messages = [
          'Executando importação secundária...',
          'Será apresentado um relatório ao final dessa importação',
          'Aguarde, as informações dos lotes estão sendo atualizadas'
        ]
        const interval = this.triggerLoopingMessages(messages, 3500)
        service.uploadCsvImportacaoSecundaria(this.leilao.id, formData)
          .then((response) => {
            console.log(response)
            this.clearFields()
            clearInterval(interval)
            clearInput()
            this.$loaderOverlay.hide()
            this.load()
            setTimeout(() => {
              this.openResultadoImportacaoSecundaria()
            }, 600)
          })
          .catch((error) => {
            alert('Erro ao atualizar lotes; ' + this.printError(error.data.errors))
            console.log(error)
            this.$loaderOverlay.hide()
            clearInterval(interval)
            clearInput()
          })
      },
      openRelatorioPreparacaoLeilaoViewer (tipoRelatorio, titulo = '') {
        this.showRelatorioPreparacaoLeilaoViewer = true
        this.relatioPreparacaoLeilaoViewerProps = {titulo, tipoRelatorio}
      },
      openResultadoImportacaoCsvGrv () {
        this.openRelatorioPreparacaoLeilaoViewer(TIPO_RELATORIO_CSV_GRV, `Resultado da importação CSV de GRV para o leilão ${this.leilao.titulo}`)
      },
      closeResultadoImportacaoCsvGrv () {
        this.showRelatorioPreparacaoLeilaoViewer = false
      },
      openResultadoImportacaoSecundaria () {
        this.openRelatorioPreparacaoLeilaoViewer(TIPO_RELATORIO_IMPORTACAO_SECUNDARIA, `Resultados da importação secundária para o leilão ${this.leilao.titulo}`)
      },
      closeResultadoImportacaoSecundaria () {
        this.showRelatorioPreparacaoLeilaoViewer = false
      },
      grvStatusTitle (s, t) {
        return GrvStatus.StatusTitle(s, t)
      },
      loteStatus (s) {
        return LoteStatus[s]
      },
      openResultadoExportacaoDestinatarios () {
        this.montarArquivoDestinatarios()
      },
      closeResultadoExportacaoDestinatarios () {
        this.showResultadosDestinatarios = false
      },
      montarArquivoDestinatarios: async function () {
        const messages = [
          'Executando Exportação de destinatários...',
          'Será apresentado um relatório ao final dessa Exportação'
        ]
        const interval = this.triggerLoopingMessages(messages, 15000)
        service.getDestinatarios(this.leilao.id)
        .then((response) => {
          console.log(response.data)
          this.entidades = response.data
          this.createDownloadLink(this.entidades.destinatarios, `export-destinatarios-${this.leilao.titulo}.txt`)
          this.showResultadosDestinatarios = true
          this.$loaderOverlay.hide()
          clearInterval(interval)
          this.showRelatorioPreparacaoLeilaoViewer = false
        })
        .catch((error) => {
          console.log(error)
          this.$loaderOverlay.hide()
          this.showRelatorioPreparacaoLeilaoViewer = false
        })
      },
      createDownloadLink (data, filename) {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      checkGrv (grv) {
        setTimeout(() => {
          if (grv.checked) {
            if (this.grvsChecked.indexOf(grv.id) === -1) {
              this.grvsChecked.push(grv.id)
            }
          } else {
            this.grvsChecked.splice(this.grvsChecked.indexOf(grv.id), 1)
          }
        }, 300)
      },
      montarLotesParaLeilao () {
        const messages = [
          'Gerando lotes para o leilão...',
          'Pode demorar um tempo, dependendo da quantidade de lotes',
          'Aguarde...',
          'Não interrompa o processo, será gerado um relatório dos lotes gerados e não gerados'
        ]
        const interval = this.triggerLoopingMessages(messages, 9000)
        service.gerarLotes(this.leilao.id, this.grvsChecked)
          .then((response) => {
            clearInterval(interval)
            this.leilao = null
            this.clearFields()
            this.load()
            this.openResultadoGeracaoLotes()
            // this.$loaderOverlay.hide()
          })
          .catch((error) => {
            alert(this.printError(error.data.errors))
            clearInterval(interval)
            console.log(error)
            this.$loaderOverlay.hide()
          })
      },
      closeLeilaoPreparado () {
        this.$loaderOverlay.open()
        this.$nextTick(() => {
          this.forcarNovaImportacao = false
          setTimeout(() => {
            this.$loaderOverlay.hide()
          }, 1000)
        })
      },
      montarLotesParaLeilaoIndividualmente: async function () {
        let counter = 0
        let primeiroLote = false
        this.$loaderOverlay.open()
        let errors = []
        for (let grv of this.grvsChecked) {
          primeiroLote = counter === 0
          ++counter
          try {
            this.$loaderOverlay.message(`Gerando lote ${counter} de ${this.grvsChecked.length}...`)
            const result = await service.gerarLote(this.leilao.id, grv, this.grvsChecked.length, primeiroLote)
            console.log(result)
          } catch (e) {
            errors.push(this.printError(e))
            console.log(e)
          }
        }
        if (errors.length > 0) alert(errors.join('\n'))
        this.leilao = null
        this.clearFields()
        if (this.forcarNovaImportacao) {
          this.forcarNovaImportacao = false
        }
        this.load()
        setTimeout(() => {
          this.openResultadoGeracaoLotes()
        }, 600)
      },
      triggerLoopingMessages (messages = [], time = 5000) {
        if (!messages.length) {
          return null
        }
        let position = 0
        this.$loaderOverlay.open().message(messages[position])
        return setInterval(() => {
          if (position > messages.length - 1) {
            position = 0
          }
          this.$loaderOverlay.message(messages[position])
          ++position
        }, time)
      },
      clearFields () {
        this.grvsAptas = []
        this.grvsChecked = []
        this.filterKey = ''
        this.checkedAll = false
      },
      gerarPlanilhaExtratoLeilao () {
        this.$bar.start()
        this.$loaderOverlay.open().message('Gerando documento, aguarde...')
        service.gerarPlanilhaExtratoLeilao(this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            createDownloadLink(response.data, `COMUNICAÇÃO DE VENDA - ${this.leilao.titulo} - 009.xls`)
            this.$bar.finish()
            this.$loaderOverlay.hide()
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      alterarVisibilidadeNaHome () {
        if (confirm('Tem certeza?')) {
          service.alterarStatusAparecerNaHome(this.$route.params.id, this.leilao.forcarAparecerNaHome)
            .then(response => {})
            .catch(error => {
              alert('Não foi possível alterar o status. Tente novamente')
              console.log(error)
              this.leilao.forcarAparecerNaHome = !this.leilao.forcarAparecerNaHome
            })
        }
      },
      forceCadastrarManual () {
        this.forceCadastroManual = true
      },
      openResultadoGeracaoLotes () {
        this.showResultadosGeracaoLotes = true
      },
      closeResultadoGeracaoLotes () {
        this.showResultadosGeracaoLotes = false
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      checkAllItems (array, fn) {
        this.checkedAll = !this.checkedAll
        array.forEach(item => {
          item.checked = this.checkedAll
          fn(item)
        })
      },
      checkAllGrvs () {
        this.checkAllItems(this.grvsAptas, this.checkGrv)
      },
      checkAllLotes () {
        this.checkAllItems(this.leilao.lotes, this.checkLote)
      },
      gerarArquivoRemessa () {
        if (!confirm('Confirmar gerar arquivo de remessa?')) {
          return
        }
        this.$loaderOverlay.open().message('Gerando arquivo, aguarde')
        service.gerarArquivoRemessa(this.$route.params.id)
          .then(response => {
            service.getPublicLinkRemessaS3(response.data.token)
              .then(result => {
                this.$loaderOverlay.hide()
                console.log(response)
                const link = document.createElement('a')
                link.href = result.data
                link.setAttribute('target', '_blank')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              })
              .catch(error => {
                this.$loaderOverlay.hide()
                alert(this.printError(error.data.errors))
              })
          })
          .catch(error => {
            this.$loaderOverlay.hide()
            alert(this.printError(error.data.errors))
          })
      },
      forcarOutraImportacao () {
        if (!confirm('Confirmar fazer uma importação complementar para este leilão?')) return
        this.clearFields()
        this.forcarNovaImportacao = !this.forcarNovaImportacao
      },
      gerarPlanilhaNotasLeilao () {
        this.$bar.start()
        this.$loaderOverlay.open().message('Gerando documento, aguarde...')
        service.gerarPlanilhaNotas(this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            console.log(response.data)
            createDownloadLink(response.data, `CSV-NOTAS-${this.leilao.titulo}.xls`)
            this.$loaderOverlay.hide()
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          alert(this.printError(response.data.errors))

          console.log(response)
        })
      }
    }
  }
</script>

<template>
  <div>
    <email-cobranca-view ref="cobrancaView"></email-cobranca-view>
    <email-automatico-view ref="emailAutomaticoView"></email-automatico-view>
    <copiar-lotes-view ref="copiarLotesView"></copiar-lotes-view>
    <transition name="slide">
      <div v-if="leilao !== null" class="content-transition">
        <btn-status-confirmar :Status="getStatus" ref="confirmarStatus"></btn-status-confirmar>
        <grafico-leilao-dash class="hidden-print"></grafico-leilao-dash>
        <div class="fade-in-down">
          <div class="bg-light lter b-b wrapper-md">
            <div class="m-b">
              <u-button-group v-model="leilao.forcarAparecerNaHome" :options="visibilityOptions" class="m-b pull-right" @change="alterarVisibilidadeNaHome" v-if="leilao.status === Status.STATUS_ENCERRADO"></u-button-group>
              <h1 class="m-n font-thin h3">{{ leilao.titulo }}</h1>
              <span
                class="label no-radius bg-dark">{{ leilao.categoria ? leilao.categoria.nome : 'Sem Categoria' }}</span>
              <span class="label m-l-n-xxs no-radius bg-success ">{{HelperTipo(leilao.tipo)}}</span>
              <span v-if="leilao.leilaoJudicial" class="label m-l-n-xxs no-radius bg-warning">Judicial</span>
              <span v-if="leilao.loteado" class="label m-l-n-xxs no-radius bg-primary">Loteado</span>
            </div>
            <div class="row">
              <div class="col-xs-6">
                <btn-controle :leilao="leilao" :ACL="ACL" :currentUser="currentUser"></btn-controle>
                <btn-edital :leilao="leilao" :ACL="ACL" :currentUser="currentUser"></btn-edital>
                <btn-acoes-planilhas-leilao
                  @gerarPlanilhaExtratoLeilao="gerarPlanilhaExtratoLeilao"
                  @gerarPlanilha005="gerarPlanilha005"
                  @gerarPlanilhaNotas="gerarPlanilhaNotasLeilao"
                ></btn-acoes-planilhas-leilao>
                <!--<u-button @click="abrirMonitorComitente()" class="btn btn-sm btn-white hidden-print"><i
                  class="fa fa-history m-r-xs"></i> Acompanhamento Comitente
                </u-button>-->
                <!--<u-button @click="abrirPregao()" class="btn btn-sm btn-black hidden-print"><i
                  class="fa fa-gamepad m-r-xs"></i> Controle do Leilão
                </u-button>-->
                <!--<u-button @click="abrirPregaoLeiloeiro()" class="btn btn-sm btn-black hidden-print"><i
                  class="fa fa-user-o m-r-xs"></i> Tela Leiloeiro
                </u-button>-->
              </div>
              <!--<div class="col-xs-4">
                <u-button-group v-model="diasVeiculoNoPatio" :options="diasVeiculoNoPatioOptions" class="m-r"></u-button-group>
                <u-button @click="prepararLeilao" class="btn btn-sm btn-danger hidden-print">
                  Preparar leilão
                </u-button>
              </div>-->
              <div class="col-xs-6 text-right">

                <btn-status v-if="ACL.check('alterar_status_leilao', currentUser.id)" :Status="getStatus" :value="leilao.status" @input="confirmarAlteracaoStatus"
                            class="hidden-print"></btn-status>
                <u-button class="btn btn-sm btn-info hidden-print" tabindex="1" @click.prevent="print">
                  <i class="fa fa-print m-r-xs"></i> Imprimir
                </u-button>
                <btn-relatorios :leilao="leilao" class="hidden-print"></btn-relatorios>
                <btn-acoes
                  @renovarCache="renovarCache"
                  @emailsAutomaticos="$refs.emailAutomaticoView.load(leilao.id)"
                  @updateTransmissaoUrl="updateTransmissaoUrl"
                  @gerarArquivoRemessa="gerarArquivoRemessa"
                  :leilao="leilao"></btn-acoes>
                <u-button class="btn btn-sm btn-default hidden-print" tabindex="1" @click.prevent="editar">
                  <i class="fa fa-edit m-r-xs"></i> Editar
                </u-button>
              </div>
            </div>
            <div class="m-t" v-if="ENV_INFRA === 'local'">
              <u-button v-if="!sync" @click="sincronizarLeilaoLocal">
                <i class="fa fa-terminal m-r-xs"></i> Iniciar transição para leilão local
              </u-button>
              <shell-sync :shellResponse="shellResponse" v-if="sync"/>
            </div>
            <div class="m-t" v-else>
              Online...
            </div>
          </div>
          <div class="wrapper-md">
            <div>
              <img src="~assets/img/leilaoico.png" height="40">
              <div class="row">
                <div class="col-xs-6">
                  <h4>{{ leilao.resumo }}</h4>
                  <p><a target="_blank" :href="'https://www.aplleiloes.com.br/leilao/' + leilao.id">www.aplleiloes.com.br/leilao/{{leilao.id}}</a>
                  </p>
                  <p>
                    Publicação: <strong>{{ moment(leilao.dataPublicacao.date).format('LLLL') }}</strong> <br>
                    Abertura: <strong>{{ moment(leilao.dataAbertura.date).format('LLLL') }}</strong> <span
                    v-if="leilao.autoFechamento" class="label bg-dark">Automático</span>
                  </p>
                  <p v-if="leilao.tipo !== 1">Tempo do Pregão: <strong>{{ leilao.timerPregao }} segundos</strong></p>
                  <p>Porcentagem de cobrança: <strong>{{ +leilao.porcentagemCobranca }}% do valor do arremate</strong></p>
                </div>
                <div class="col-xs-6 text-right">
                  <p class="h4">#{{ leilao.id }}</p>
                  <h5>Criado {{ moment(leilao.dataCadastro.date).calendar() }}</h5>
                  <p class="m-t m-b">
                    Leilão Interno: <strong>{{ leilao.syncExtra ? leilao.syncExtra.codigoInterno : '' }}</strong><br>
                    ID Interno: <strong>#{{ leilao.syncId }}</strong>
                  </p>
                </div>
              </div>
              <div class="well m-t bg-light lt">
                <div class="row">
                  <div class="col-xs-6">
                    <strong>LEILOEIRO:</strong>
                    <h4>{{ leilao.leiloeiro ? leilao.leiloeiro.pessoa.nome : 'Sem leiloeiro definido' }}</h4>
                    <p>
                  <span v-if="leilao.comissao">Comissão: {{ leilao.comissao }}% <span v-if="leilao.cobraComissao"
                                                                                      class="label bg-light">Será cobrado</span><br></span>
                    </p>
                    <div v-if="leilao.local">
                      <strong>LOCAL:</strong>
                      <h4>{{ leilao.local.nome }}</h4>
                      <p>
                        {{ leilao.local.descricao }}<br>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-6">
                    <strong>INFORMAÇÕES:</strong>
                    <p>
                      Visitação: {{ leilao.infoVisitacao }}<br>
                      Retirada: {{ leilao.infoRetirada }}<br>
                      Observações: {{ leilao.observacao }}<br>
                    </p>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <!--------------------------------------Raphael-------------------------------------->
              <div class="col-xs-12" v-if="!isLeilaoPreparado && !(grvsAptas && grvsAptas.length)">
                <div class="text-center" v-if="isNenhumLoteGerado">
                  <span class="alert alert-danger">
                    <strong>Atenção: </strong>Nenhum lote foi gerado
                    <!--<u-button @click="openResultadoGeracaoLotes" class="btn btn-sm btn-danger hidden-print">
                      Resultados da geração de lotes
                    </u-button>-->
                  </span>
                </div>
                <div class="text-center" v-else-if="importadoPorCsvPlacas">
                  <div>
                    <span class="alert alert-danger">
                      <strong>Atenção: </strong>Nenhum lote foi gerado
                      <u-button @click="openResultadoImportacaoCsvGrv" class="btn btn-sm btn-info hidden-print m-l">
                        Relatório da importação
                      </u-button>
                    </span>
                  </div>
                </div>
                <div class="preparar-leilao">
                  Selecione o orgão:
                  <u-button-group v-model="tipoProcesso" :options="tipoProcessos" class="m-r"></u-button-group>
                  <br>
                  Somente veículos no pátio há:
                  <u-button-group v-model="diasVeiculoNoPatio" :options="diasVeiculoNoPatioOptions" class="m-r"></u-button-group>
                  <u-button @click="prepararLeilao" class="btn btn-lg btn-danger hidden-print m-t">
                    Preparar leilão
                  </u-button>
                  <div class="m">ou</div>
                  <u-button @click="forceCadastrarManual" class="btn btn-md btn-success hidden-print">
                    Cadastrar lotes manualmente
                  </u-button>
                  <div class="m">ou</div>
                  <input type="file" ref="inputCsvPlacas" accept=".csv" v-show="false" @change="prepararLeilaoComCsvDePlacas">
                  <u-button @click="$refs.inputCsvPlacas.click()" class="btn btn-md btn-success hidden-print">
                    <i class="fa fa-upload"></i> Importar csv com GRVs para preparar o leilão
                  </u-button>
                </div>
              </div>
              <div class="row" v-else-if="!isLeilaoPreparado">
                <div class="col-xs-3">
                  <h4>GRVs Aptas para o Leilão <span class="badge">{{ filteredDataGrvs && filteredDataGrvs.length }}</span></h4>
                </div>
                <div class="col-xs-4" v-if="!importadoPorCsvPlacas">
                  <u-button-group v-model="diasVeiculoNoPatio" :options="diasVeiculoNoPatioOptions" class="m-r"></u-button-group>
                  <u-button @click="prepararLeilao" class="btn btn-sm btn-danger hidden-print">
                    Preparar leilão
                  </u-button>
                </div>
                <div class="col-xs-4" v-else>
                  <div style="display: flex; align-items: center;">
                    <div>
                      <small>
                        Placas inválidas: {{importacaoCsvPlacas.grvsInvalidas.length}} <br>
                        Placas não encontradas: {{importacaoCsvPlacas.grvsNaoEncontradas.length}}
                      </small>
                    </div>
                    <u-button @click="openResultadoImportacaoCsvGrv" class="btn btn-sm btn-success hidden-print m-l">
                      Relatório da importação
                    </u-button>
                  </div>
                </div>
                <div class="col-xs-5">
                  <div class="pull-right w-md">
                    <input v-model="filterKey" type="text" placeholder="Pesquisar"
                           class="input-sm form-control hidden-print">
                  </div>
                  <div class="pull-right m-r-sm">
                    <button class="btn-sm btn-danger" @click="closeLeilaoPreparado">Cancelar</button>
                  </div>
                  <div class="pull-right m-r-sm">
                    <u-button @click="montarLotesParaLeilaoIndividualmente" class="btn btn-sm btn-info pull-left hidden-print m-b-sm" :disabled="!grvsChecked.length">
                      Gerar lotes com itens selecionados
                    </u-button>
                  </div>
                </div>
              </div>
              <table class="table-lotes-leilao table table-clicked table-striped bg-white b-a" v-if="!isLeilaoPreparado && (grvsAptas && grvsAptas.length)">
                <thead>
                <tr>
                  <th class="hidden-print" style="width: 30px">
                    <label class="i-checks m-b-none">
                      <input type="checkbox" v-model="checkedAll" @click="checkAllGrvs" tabindex="0"
                             aria-checked="false"
                             aria-invalid="false"><i></i>
                    </label>
                  </th>
                  <th class="text-nowrap" style="width: 60px" @click="sortBy('numero')"
                      :class="{ active: sortKey === 'numero' }">
                    GRV <i class="fa" style="font-size: 10px"
                           :class="sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('placa')"
                      :class="{ active: sortKey === 'placa' }">
                    Placa <i class="fa" style="font-size: 10px"
                             :class="sortOrders['placa'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('placaOriginal')"
                      :class="{ active: sortKey === 'placaOriginal' }">
                    Placa Original <i class="fa" style="font-size: 10px"
                             :class="sortOrders['placaOriginal'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('chassi')"
                      :class="{ active: sortKey === 'chassi' }">
                    Chassi <i class="fa" style="font-size: 10px"
                              :class="sortOrders['chassi'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap"  @click="sortBy('chassi')"
                      :class="{ active: sortKey === 'chassi' }">
                    Status <i class="fa" style="font-size: 10px"
                              :class="sortOrders['status'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap"  @click="sortBy('statusLote')"
                      :class="{ active: sortKey === 'statusLote' }">
                    Ultimo leilão <i class="fa" style="font-size: 10px"
                              :class="sortOrders['statusLote'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="hidden-print"></th>
                </tr>
                </thead>
                <tbody v-if="filteredDataGrvs && filteredDataGrvs.length">
                <tr class="leilao-list-lote-item" v-for="grv in filteredDataGrvs">
                  <td class="hidden-print">
                    <label class="i-checks m-b-none">
                      <input type="checkbox" v-model="grv.checked" @click="checkGrv(grv)" tabindex="0"
                             aria-checked="false"
                             aria-invalid="false"><i></i>
                    </label>
                  </td>
                  <td>
                    <router-link :to="{name: urlGrv, params: {id: grv.id}}" target="_blank" replace><u>{{ grv.numero || '-' }}</u></router-link>
                  </td>
                  <td>{{grv.placa}}</td>
                  <td>{{grv.placaOriginal}}</td>
                  <td>{{grv.chassi}}</td>
                  <td tabindex="0">
                    <span :style="'color: ' + grvStatusTitle(grv.status, 'color')">{{grvStatusTitle(grv.status)}}</span>
                  </td>
                  <td tabindex="0">
                    <span v-if="grv.statusLote !== null">{{loteStatus(grv.statusLote).titulo}}</span>
                    <span style="color:green" v-else>Não leiloado</span>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="leilao-list-lote-item">
                  <td class="hidden-print text-center" colspan="5">Nada encontrado</td>
                </tr>
                </tbody>
              </table>
              <!-------------------------------------------------------------------------------------------------------->
              <div class="row m-b-md" v-if="isLeilaoPreparado">
                <div class="col-xs-12">
                  <btn-acoes-complementares-preparacao-leilao class="pull-right"
                                                              @forcarOutraImportacao="forcarOutraImportacao"
                                                              @importacaoSecundaria="$refs.inputImportacaoSecundaria.click()"
                  >
                  </btn-acoes-complementares-preparacao-leilao>

                  <btn-relatorios-preparacao-leilao class="pull-right m-r-sm"
                                                    @openResultadoGeracaoLotes="openResultadoGeracaoLotes"
                                                    @openResultadoImportacaoCsvGrv="openResultadoImportacaoCsvGrv"
                                                    @openResultadoImportacaoSecundaria="openResultadoImportacaoSecundaria"
                                                    @openResultadoExportacaoDestinatarios="openResultadoExportacaoDestinatarios"
                  >
                  </btn-relatorios-preparacao-leilao>
                  <input type="file" ref="inputImportacaoSecundaria" accept=".csv" v-show="false" @change="importacaoSecundaria" />
                </div>
              </div>
              <div class="row" v-if="isLeilaoPreparado">
                <div class="col-xs-2"><h4>Lotes <span
                  class="badge">{{ filteredDataLotes && filteredDataLotes.length }}</span>
                </h4>
                </div>
                <div class="col-xs-10">
                  <u-button @click="cadastraLote" class="btn btn-sm btn-success pull-right hidden-print m-b-sm">
                    Cadastrar Lote
                  </u-button>

                  <!--<filtros-lote class="pull-right hidden-print m-r-sm"></filtros-lote>-->
                  <div class="pull-right w-md m-r-sm">
                    <input v-model="filterKey" type="text" placeholder="Pesquisar"
                           class="input-sm form-control hidden-print">
                    <span v-if="filterKey" class="visible-print">Filtro: {{ filterKey }}</span>
                  </div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLote" class="pull-right m-r"></u-button-group>
                  <!--<u-button-group :multiSelect="true" v-model="filtro.situacao"
                                  :options="situacaoLote" class="pull-right m-r"></u-button-group>-->
                  <filtro-status-lotes :options="situacaoLote" v-model="filtro.situacao"
                                       class="pull-right m-r"></filtro-status-lotes>
                </div>
              </div>

              <table class="table-lotes-leilao table table-clicked bg-white b-a" v-if="isLeilaoPreparado">
                <thead>
                <tr>
                  <th class="hidden-print" style="width: 10px">
                    <label class="i-checks m-b-none">
                      <input type="checkbox" v-model="checkedAll" @click="checkAllLotes" tabindex="0"
                             aria-checked="false"
                             aria-invalid="false"><i></i>
                    </label>
                  </th>
                  <th class="text-nowrap" style="width: 30px" @click="sortBy('numero')"
                      :class="{ active: sortKey === 'numero' }">
                    LT <i class="fa" style="font-size: 10px"
                          :class="sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" style="width: 40px" @click="sortBy('grvNumero')"
                      :class="{ active: sortKey === 'grvNumero' }">
                    GRV <i class="fa" style="font-size: 10px"
                          :class="sortOrders['grvNumero'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="hidden-print"></th>
                  <th class="text-nowrap" @click="sortBy('titulo')" :class="{ active: sortKey === 'titulo' }">
                    DESCRIÇÃO <i class="fa" style="font-size: 10px"
                                 :class="sortOrders['titulo'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('patio')" :class="{ active: sortKey === 'patio' }">
                    PÁTIO <i class="fa" style="font-size: 10px"
                             :class="sortOrders['patio'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('placa')" :class="{ active: sortKey === 'placa' }">
                    PLACA <i class="fa" style="font-size: 10px"
                                 :class="sortOrders['placa'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" @click="sortBy('comitente')" :class="{ active: sortKey === 'comitente' }">
                    COMITENTE <i class="fa" style="font-size: 10px"
                                 :class="sortOrders['comitente'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
                  </th>
                  <th class="text-nowrap" style="width: 120px">MÍNIMO</th>
                  <th class="text-nowrap" style="width: 120px">LANCE ATUAL</th>
                  <th class="text-nowrap" style="width: 120px">ARREMATE</th>
                  <th class="text-nowrap" style="width: 120px">VALOR TOTAL</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" :class="bindClassLoteList(lote)"
                    v-for="lote in filteredDataLotes">
                  <td class="hidden-print" v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">
                    <label class="i-checks m-b-none">
                      <input type="checkbox" v-model="lote.checked" @click="checkLote(lote)" tabindex="0"
                             aria-checked="false"
                             aria-invalid="false"><i></i>
                    </label>
                  </td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">{{ lote.numero }}</td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }" >
                    <router-link :to="{name: urlGrv, params: {id: lote.grvId}}" target="_blank" replace><u>{{ lote.grvNumero || '-' }}</u></router-link>
                    <br>
                    <span class="text-danger small" v-if="lote.bloqueadoParaLeilao">GRV bloqueada para leilão</span>
                  </td>
                  <td class="hidden-print" v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">
                    <img width="50" src="../assets/lote-retirado.jpg" loading="lazy" v-if="lote.status === STATUS_RETIRADO">
                    <img width="50" :src="lote.urlMin" loading="lazy" v-else>
                  </td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">
                    <router-link :to="{name: 'lotes.visualizar', params: {leilao: leilao.id, id: lote.id}}">{{
                      lote.titulo.toUpperCase() }}
                    </router-link>
                  </td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">{{ lote.patioNome }}</td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">
                    <router-link :to="{name: 'lotes.visualizar', params: {leilao: leilao.id, id: lote.id}}">{{
                      lote.placa && lote.placa.toUpperCase() }}
                    </router-link>
                  </td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">{{ lote.comitente ? lote.comitente : 'Sem comitente' }}</td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">R$ {{ lote.valorMinimo | moeda }}</td>
                  <td class="text-nowrap" v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">R$ {{ lote.ultimoLanceValor | moeda }}
                    <span v-if="lote.ultimoLanceApelido && lote.ultimoLanceApelido === 'PLATEIA'" title="Plateia"
                    class="label label-xs no-radius bg-white">P
                      <span style="color: gray" v-if="lote.boleta">&nbsp;(Boleta <span style="font-size:14px">{{lote.boleta}}</span>)</span>
                    </span>

                    <span v-if="lote.ultimoLanceApelido && lote.ultimoLanceApelido !== 'PLATEIA'"
                    class="label label-xs no-radius bg-white text-success">{{ lote.ultimoLanceApelido }}
                      <button v-if="lote.status === 6" class="btn btn-xs m-l-xs"
                              @click="$refs.cobrancaView.load(leilao.id, lote.id)">
                        <i class="fa fa-envelope-o" title="Gerar Cobrança"></i>
                      </button>
                    </span>

                  </td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">R$ {{ lote.valorArremate | moeda }}</td>
                  <td v-bind:class="{ 'alert-danger': lote.status === STATUS_RETIRADO }">R$ {{ (lote.valorComTaxas || 0.00) | moeda }}</td>
                </tr>
                <tr v-if="ACL.check('visualizar_valores_leilao', currentUser.id)">
                  <td class="hidden-print"></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td></td>
                  <td class="text-right"><strong>Subtotal</strong></td>
                  <td>R$ {{ subTotalMinimo | moeda }}</td>
                  <!--<td>R$ {{ subTotalMeta | moeda }}</td>-->
                  <td>R$ {{ subTotalLances | moeda }}</td>
                  <td>R$ {{ subTotalArremate | moeda }}</td>
                  <td>R$ {{ subTotalArremateComTaxas | moeda}}</td>
                </tr>
                <tr v-if="leilao.cobraComissao">
                  <td class="hidden-print"></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td></td>
                  <td class="text-right no-border"><strong>Comissão {{ leilao.comissao }}%</strong></td>
                  <td>R$ {{ comissaoMinimo | moeda }}</td>
                  <!--<td>R$ {{ comissaoMeta | moeda }}</td>-->
                  <td>R$ {{ comissaoLances | moeda }}</td>
                  <td>R$ {{ comissaoArremate | moeda }}</td>
                </tr>
                <tr v-if="leilao.cobraTaxasAdicionais">
                  <td class="hidden-print"></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td></td>
                  <td class="text-right no-border"><strong>Taxa ICMS {{leilao.taxaIcms}}%</strong></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr v-if="leilao.cobraTaxasAdicionais">
                  <td class="hidden-print"></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td class="hidden-print"></td>
                  <td></td>
                  <td></td>
                  <td class="text-right no-border"><strong>Taxa ISS {{leilao.taxaIss}}%</strong></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <!--<tr>
                  <td colspan="3" class="text-right no-border"><strong>Total</strong></td>
                  <td><strong>R$ 21.840,47</strong></td>
                  <td><strong>R$ 22.840,47</strong></td>
                  <td><strong></strong></td>
                </tr>-->
                </tbody>
              </table>


              <div class="m-t-n m-b-lg" v-if="lotesChecked.length > 0 && leilao.lotes.length">
                Ação para selecionados:
                <select v-model="actionCheckedLotes" @change="_actionCheckedLotes">
                  <option value="">Selecione a ação</option>
                  <option v-if="ACL.check('deletar_lote_leilao', currentUser.id)" value="deletar">Excluir</option>
                  <option value="copiar">Copiar para outro leilão</option>
                </select>
              </div>

              <!-- Comitentes -->
              <div class="row" v-if="isLeilaoPreparado">

                <div v-for="comitente in leilao.comitentes" class="col-xs-4">
                  <div class="panel b-light clearfix">
                    <div class="panel-body">
                      <a class="pull-left m-r">
                        <img :src="comitente.imagem" width="100">
                      </a>
                      <div class="clear">
                        <a class="text-dark">{{ comitente.nome }}</a>
                        <small class="block text-muted">{{ comitente.lotes }} lote{{ comitente.lotes > 1 ? 's' : '' }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>


              </div>

              <div class="line"></div>
              <div class="row">
                <div class="col-xs-6"><h4>Documentos públicos</h4></div>
                <div class="col-xs-6">
                  <u-button class="btn btn-sm btn-default fileContainer pull-right hidden-print m-b-sm">
                    Cadastrar Documento
                    <input
                      @change="uploadDocumento" ref="fileDocumento" type="file"/>
                  </u-button>
                </div>
              </div>
              <table class="table table-clicked table-striped bg-white b-a">
                <thead>
                <tr>
                  <th>DOCUMENTO</th>
                  <th>ARQUIVO</th>
                  <th style="width: 100px"></th>
                </tr>
                </thead>
                <tbody>
                <tr :id="'documento' + documento.id" v-for="documento in leilao.documentos">
                  <td>{{ documento.nome }}</td>
                  <td><a :href="documento.urlStorage" target="_blank">{{ documento.arquivo }}</a></td>
                  <td><a @click="removeDocumento(documento.id)" class="text-danger">Remover</a></td>
                </tr>
                </tbody>
              </table>
            </div>
            <u-button class="btn btn-sm btn-default hidden-print" tabindex="1" @click.prevent="renovarCache">
              <i class="fa fa-hdd-o m-r-xs"></i> Renovar Cache
            </u-button>
          </div>
        </div>
      </div>
    </transition>
    <popup-viewer @close="closeResultadoGeracaoLotes" v-if="showResultadosGeracaoLotes" :title="`Resultados da geração de lotes para o leilão ${leilao.titulo}`">
      <ResultadoGeracaoLotesLeilao :quantidadeDeGrvsSelecionadas="leilao.quantidadeDeGrvsSelecionadas" :lotesNaoGerados="leilao.lotesNaoGerados" />
    </popup-viewer>
    <popup-viewer @close="closeResultadoImportacaoCsvGrv" v-if="showRelatorioPreparacaoLeilaoViewer" :title="relatioPreparacaoLeilaoViewerProps.titulo">
      <HistoricoLogsImportacaoPreparacaoLeilao :leilaoId="leilao.id" :tipoLog="relatioPreparacaoLeilaoViewerProps.tipoRelatorio"/>
    </popup-viewer>
    <popup-viewer @close="closeResultadoExportacaoDestinatarios" v-if="showResultadosDestinatarios" :title="`Resultados dos destinatários do leilão ${leilao.titulo}`">
      <ResultadoDestinatarios :total="entidades.total" :destinatariosErroCep="entidades.cepInvalido" />
    </popup-viewer>

  </div>
</template>

<style scoped>
  .preparar-leilao {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px;
  }
  .bloqueado-para-leilao {
    animation: bloqueado-leilao 1.5s infinite;
  }
  @keyframes bloqueado-leilao {
    0%, 100% {
      color: red;
      background-color: rgba(231, 76, 60, .5);
    }
    55% {
      background-color: inherit;
      color: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// VisualizarLeilao.vue?7cb2af7f